import type {Step} from "../../components/stepper/Step.ts";
import {useMetlConnectionStep} from "../../common-process/1-metl-connection/useMetlConnectionStep.tsx";
import {useCustomerAnalysisOptionsStep} from "../1-options/useCustomerAnalysisOptionsStep.tsx";
import {useCustomerScanStep} from "../2-scanning/useCustomerScanStep.tsx";
import {useCustomerResultsStep} from "../3-results/useCustomerResultsStep.tsx";

export function useCustomerAnalysisSteps(): Step[] {
    return [
        useMetlConnectionStep(),
        useCustomerAnalysisOptionsStep(),
        useCustomerScanStep(),
        useCustomerResultsStep()
    ]
}